/**
 * Shared site-wide constants for locale routing + SEO. Kept intentionally tiny for this
 * scaffold (T68) — real content/config (brand copy, production domain, etc.) lands with T35.
 */

export const SUPPORTED_LANGUAGES = ["ar", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const RTL_LANGUAGES: SupportedLanguage[] = ["ar"];

export const DEFAULT_LANGUAGE: SupportedLanguage = "ar";

export function isSupportedLanguage(
  value: string | undefined,
): value is SupportedLanguage {
  return !!value && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

export function directionFor(lang: SupportedLanguage): "rtl" | "ltr" {
  return RTL_LANGUAGES.includes(lang) ? "rtl" : "ltr";
}

/**
 * Canonical production origin for the public site — used to build absolute canonical/hreflang/OG
 * URLs. The bare domain is canonical: `www.` is not served (it does not resolve) and is not in the
 * API's CORS allow-list.
 *
 * Note that `public/sitemap.xml` and `public/robots.txt` are static files copied verbatim into
 * `dist/`, so they hardcode this origin separately — update them alongside this constant.
 */
export const SITE_ORIGIN = "https://future-academy-eg.com";

/** Builds an absolute canonical URL for a given locale's home page, e.g. `${SITE_ORIGIN}/ar`. */
export function localeUrl(lang: SupportedLanguage): string {
  return `${SITE_ORIGIN}/${lang}`;
}
